<div class="tab-nav-items" [class.no-horizontal-offset]="noHorizontalOffset">
  @for (tab of tabItems; track tab) {
    <div class="tab-nav-item">
      <a
        [routerLinkActive]="'active'"
        [routerLink]="tab.href"
        class="tab-nav-link"
        [routerLinkActiveOptions]="{ exact: tab.isExact || false }"
      >
        <div [ngClass]="tab.isHighlighted ? 'highlighted' : ''">{{ tab.label }}</div>
      </a>
    </div>
  }
</div>
